import { BOOKED_APPOINTMENT_URL } from "../../constants/urls";
import { apiSlice } from "./apiSlice";

export const bookedAppointmentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBookedAppointments: builder.query({
      query: (q) => ({
        url: `${BOOKED_APPOINTMENT_URL}?${q ? q : ""}`,
        method: "GET",
      }),
    }),
    getBookedAppointmentByAppointmentId: builder.query({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/${id}`,
        method: "GET",
      }),
    }),
    /** Yanıtta opsiyonel calendarDaySummaries: [{ date, hasActiveBookableSlots }] — bkz. docs/booked-appointment-calendar-summary.md */
    getBookedAppointmentsByDoctorId: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/bydoctorid/${data.id}${data.q ? `?${data.q}` : ""}`,
        method: "GET",
      }),
    }),
    getAvailableAppointmentsByDoctorId: builder.query({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/availableappointments/bydoctorid/${id}`,
        method: "GET"
      }),
    }),
    getAllAvailableAppointmentsByDoctorId: builder.query({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/all/byDoctorId/${id}`,
        method: 'GET'
      })
    }),
    getBookedAppointmentsByPatientId: builder.query({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/bypatientid/${data.id}${data.q ? "?" + data.q : ""}`,
        method: "GET",
      }),
    }),
    getPastAppointmentsByPatientId: builder.query({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/past/byPatientId/${data.id}${data.q ? "?" + data.q : ""}`,
        method: "GET"
      })
    }),
    getPastAppointmentsByDoctorId: builder.query({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/past/bydoctorid/${data.id}?${data.q ? data.q : ''}`,
        method: 'GET'
      })
    }),
    /** @deprecated Legacy — use getDoctorCalendarDates */
    getDoctorBookedAppointmentDates: builder.query({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/dates/bydoctorid/${data.id}/${data.offset}`,
        method: 'GET'
      })
    }),
    /** Takvim gün özetleri — bkz. docs/DOKTOR-TAKVIM-CALENDAR-API.md */
    getDoctorCalendarDates: builder.query({
      query: (doctorId) => ({
        url: `${BOOKED_APPOINTMENT_URL}/calendar/${doctorId}/dates`,
        method: 'GET',
      }),
    }),
    /** Seçili günün slot listesi (boş + dolu) */
    getDoctorCalendarDay: builder.query({
      query: ({ id, date }) => ({
        url: `${BOOKED_APPOINTMENT_URL}/calendar/${id}/day/${date}`,
        method: 'GET',
      }),
    }),
    getDoctorsFreeSlots: builder.query({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/FreeSlotsByDoctorId/${id}`,
        method: 'GET'
      })
    }),
    /** @deprecated Legacy — use getDoctorCalendarDay */
    getBookedAppointmentsByDate: builder.query({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/dates/bydoctorid/${data.id}/${data.date}/${new Date().getTimezoneOffset()}`,
        method: 'GET',
      }),
    }),
    updateBookedAppointmentByDoctor: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/update`,
        method: 'PUT',
        body: data
      })
    }),
    updateBookedAppointmentIsActive: builder.mutation({
      query: ({ appointmentId, isActive }) => ({
        url: `${BOOKED_APPOINTMENT_URL}/UpdateActiveStatus/${appointmentId}?isActive=${isActive}`,
        method: "PUT",
      }),
    }),
    updateMultipleBookedAppointmentIsActive: builder.mutation({
      query: ({ appointmentIds, isActive }) => ({
        url: `${BOOKED_APPOINTMENT_URL}/UpdateMultipleActiveStatus`,
        method: "PUT",
        body: { appointmentIds, isActive },
      }),
    }),
    updateBookedAppointmentAdmin: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/admin`,
        method: 'PUT',
        body: data
      }),
    }),
    getBookedAppointmentById: builder.query({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/byTreatmentDemandId/${id}`,
        method: "GET",
      }),
    }),
    changeStatus: builder.mutation({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/ChangeStatus/${id}`,
        method: "PUT",
      }),
    }),
    bookedAppointmentUploadFiles: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/uploadfiles`,
        method: "POST",
        body: data,
      }),
    }),
    finalizeAppointment: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/FinalizeAppointment`,
        method: 'PUT',
        body: data
      })
    }),
    changeAppointment: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/changeappointment`,
        method: 'POST',
        body: data
      })
    }),
    getAvailableDatesByBranch: builder.mutation({
      query: (data) => {
        const specialtyId = data?.specialtyId ?? data?.branchId;
        const { branchId, ...rest } = data || {};
        return {
          url: `${BOOKED_APPOINTMENT_URL}/availableAppointmentDates/bySpecialtyId`,
          method: "POST",
          body: {
            ...rest,
            specialtyId,
          },
        };
      },
    }),
    cancelAppointment: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/Cancel`,
        method: "PUT",
        body: data
      })
    }),
    fakeMakeAppointment: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/fakecreate`,
        method: "PUT",
        body: data
      })
    }),
    createAppointmentsForDoctor: builder.mutation({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/createappointments/${id}`,
        method: 'POST'
      })
    }),
    createAppointmentsForDoctorByDay: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/createappointmentsbyday`,
        method: 'POST',
        body: data
      })
    }),
    createClosedAppointmentsForDoctor: builder.mutation({
      query: (data) => ({
        url: `${BOOKED_APPOINTMENT_URL}/CreateClosedAppointment`,
        method: 'POST',
        body: data
      })
    }),
    deleteBookedAppointment: builder.mutation({
      query: (id) => ({
        url: `${BOOKED_APPOINTMENT_URL}/${id}`,
        method: 'DELETE'
      })
    }),
    clearAppointmentHizmetler: builder.mutation({
      query: (appointmentId) => ({
        url: `${BOOKED_APPOINTMENT_URL}/ClearHizmetler/${appointmentId}`,
        method: 'DELETE'
      })
    }),
    clearAppointmentMuayeneBilgisi: builder.mutation({
      query: (appointmentId) => ({
        url: `${BOOKED_APPOINTMENT_URL}/ClearMuayeneBilgisi/${appointmentId}`,
        method: 'DELETE'
      })
    }),
    createReceteForAppointment: builder.mutation({
      query: (appointmentId) => ({
        url: `${BOOKED_APPOINTMENT_URL}/CreateRecete/${appointmentId}`,
        method: 'POST'
      })
    }),
    createHbysReportUrl: builder.mutation({
      query: (appointmentId) => ({
        url: `${BOOKED_APPOINTMENT_URL}/CreateHbysReportUrl/${appointmentId}`,
        method: 'POST'
      })
    })
  })
});

export const {
  useChangeStatusMutation,
  useLazyChangeStatusMutation,
  useGetBookedAppointmentByAppointmentIdQuery,
  useLazyGetBookedAppointmentByIdQuery,
  useLazyGetBookedAppointmentByAppointmentIdQuery,
  useUpdateBookedAppointmentAdminMutation,
  useGetBookedAppointmentsByDoctorIdMutation,
  useLazyGetAllAvailableAppointmentsByDoctorIdQuery,
  useFinalizeAppointmentMutation,
  useLazyGetBookedAppointmentsQuery,
  useLazyGetAvailableAppointmentsByDoctorIdQuery,
  useChangeAppointmentMutation,
  useLazyGetDoctorBookedAppointmentDatesQuery,
  useLazyGetBookedAppointmentsByDateQuery,
  useLazyGetDoctorCalendarDatesQuery,
  useLazyGetDoctorCalendarDayQuery,
  useGetBookedAppointmentsByPatientIdQuery,
  useLazyGetPastAppointmentsByDoctorIdQuery,
  useGetPastAppointmentsByPatientIdQuery,
  useLazyGetPastAppointmentsByPatientIdQuery,
  useGetAvailableDatesByBranchMutation,
  // useMakeAppointmentMutation,
  // useUploadBookedAppointmentFilesMutation
  useLazyGetBookedAppointmentsByPatientIdQuery,
  useUpdateBookedAppointmentByDoctorMutation,
  useBookedAppointmentUploadFilesMutation,
  useCancelAppointmentMutation,
  useFakeMakeAppointmentMutation,
  useCreateAppointmentsForDoctorMutation,
  useCreateAppointmentsForDoctorByDayMutation,
  useDeleteBookedAppointmentMutation,
  useUpdateBookedAppointmentIsActiveMutation,
  useUpdateMultipleBookedAppointmentIsActiveMutation,
  useLazyGetDoctorsFreeSlotsQuery,
  useCreateClosedAppointmentsForDoctorMutation,
  useLazyCreateClosedAppointmentsForDoctorMutation,
  useClearAppointmentHizmetlerMutation,
  useClearAppointmentMuayeneBilgisiMutation,
  useCreateReceteForAppointmentMutation,
  useCreateHbysReportUrlMutation
} = bookedAppointmentApiSlice;
